export const ROUTE_CONSTANTS = {
  LOGIN: '/login',
  CHAT: '/chat',
  HOME: '/',
  DASHBOARD: '/dashboard'
} as const;
